import React from 'react';
import { translate } from '../../Services/translation';

const Certificate = (props) => {
  const { labelKey, icon, certificateDescription } = props;
  const getIconPath = () => {
    return '/ui/images/sprites/be-group.svg#' + icon;
  };

  return (
    <section className='configurator-box'>
      <header>
        <svg className='configurator-box__icon'>
          <use href={getIconPath()}></use>
        </svg>
        <h4 className='configurator-box__title'>{translate(labelKey)}</h4>
      </header>
      <div className='configurator-box__content'>{translate(certificateDescription)}</div>
    </section>
  );
};

export default Certificate;
